import { MDBDataTable } from "mdbreact";
import React, { useEffect, useState } from "react";
import { MutatingDots } from 'react-loader-spinner';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Bounce, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Badge, Button, Card, CardBody, CardTitle, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import api from "../../services/api";
import { setBreadcrumbItems } from "../../store/actions";
import "./datatables.scss";


const RefundList = (props) => {
  document.title = "Refund | Technical Hub - All Refunds";

  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Refunds", link: "#" },
    { title: "Refunds", link: "#" },
  ];

  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const backendFileUrl = process.env.REACT_APP_BACKEND_IMAGE_URL;


  const [refundData, setRefundData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [refundToDelete, setRefundToDelete] = useState(null);
  const [fileModal, setFileModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  useEffect(() => {
    props.setBreadcrumbItems('Refund List', breadcrumbItems);
    fetchRefundData();
  }, []);

  const fetchRefundData = async () => {
    try {
      const response = await api.get(`${backendUrl}get-refund-data`);

      console.log("Refund Data:", response.data);
      if (response.status === 200) {
        setRefundData(response.data.data || []);
        setLoading(false);
      }
    } catch (error) {
      console.log("Error fetching refund data:", error);
      toast.error("Failed to load refund data", {
        position: "top-right",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

  const toggleDeleteModal = (refund) => {
    setRefundToDelete(refund);
    setShowDeleteModal(!showDeleteModal);
  };

  const toggleFileModal = (fileUrl = "") => {
    setSelectedFile(fileUrl);
    setFileModal(!fileModal);
  };

  const handleDeleteRefund = async () => {
    try {
      if (!refundToDelete) return;

      const response = await api.delete(
        `${backendUrl}delete-refund/${refundToDelete._id}`
      );

      if (response.status === 200) {
        toast.success("Refund record deleted successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Remove the deleted refund from the state
        setRefundData(prevData =>
          prevData.filter(item => item._id !== refundToDelete._id)
        );

        // Close the modal
        setShowDeleteModal(false);
        setRefundToDelete(null);
      }
    } catch (error) {
      console.log("Error deleting refund:", error);
      toast.error("Failed to delete refund record. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleDownloadFile = (fileUrl) => {
    if (fileUrl) {
      const link = document.createElement('a');
      link.href = `${backendFileUrl}${fileUrl}`;
      link.target = '_blank';
      link.download = fileUrl.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const data = {
    columns: [
      { label: "SR No", field: "srNo", sort: "asc", width: 80 },
      { label: "Roll No", field: "roll_no", sort: "asc", width: 120 },
      { label: "Student Name", field: "name", sort: "asc", width: 150 },
      { label: "Course Name", field: "course", sort: "asc", width: 150 },
      { label: "Technology", field: "technology", sort: "asc", width: 150 },
      { label: "Refund Amount", field: "refund_amount", sort: "asc", width: 130 },
      { label: "Refund Reason", field: "refund_reason", sort: "asc", width: 200 },
      { label: "Term", field: "term", sort: "asc", width: 80 },
      { label: "Payment ID", field: "payment_id", sort: "asc", width: 180 },
      { label: "Given By", field: "refund_given_by", sort: "asc", width: 180 },
      { label: "Cashcunter", field: "cashcounter_name", sort: "asc", width: 180 },
      { label: "Document", field: "file", sort: "asc", width: 120 },
      { label: "Actions", field: "actions", sort: "asc", width: 150 },
    ],
    rows: Array.isArray(refundData) && refundData.length > 0
      ? refundData.map((refund, index) => ({
        srNo: index + 1,
        roll_no: refund?.roll_no || "N/A",
        name: refund?.name || "N/A",
        course: refund?.course || "N/A",
        technology: refund?.technology || "N/A",
        refund_amount: refund?.refund_amount ? (
          <Badge color="success" style={{ fontSize: '12px' }}>
            {formatCurrency(refund.refund_amount)}
          </Badge>
        ) : "N/A",
        refund_reason: (
          <div style={{ maxWidth: "200px", wordWrap: "break-word" }}>
            {refund?.refund_reason || "N/A"}
          </div>
        ),
        term: refund?.term ? (
          <Badge color="primary">{refund.term}</Badge>
        ) : "N/A",
        payment_id: refund?.payment_id || "N/A",
        refund_given_by: refund?.refund_given_by || "N/A",
        cashcounter_name: refund?.refund_cashcounter || "N/A",
        file: refund?.file ? (
          <div>
            <Button
              size="sm"
              color="info"
              className="me-1"
              onClick={() => toggleFileModal(refund.file)}
            >
              View
            </Button>
            <Button
              size="sm"
              color="success"
              onClick={() => handleDownloadFile(refund.file)}
            >
              Download
            </Button>
          </div>
        ) : (
          <Badge color="secondary">No File</Badge>
        ),
        actions: (
          <div>
            {/* <Link
              to={`/edit-course-refunds/${refund._id}`}
              className="btn btn-info btn-sm me-2"
            >
              Edit
            </Link> */}
            <Button
              color="danger"
              size="sm"
              onClick={() => toggleDeleteModal(refund)}
            >
              Delete
            </Button>
          </div>
        ),
      }))
      : [],
  };

  const getFileExtension = (fileUrl) => {
  if (typeof fileUrl !== 'string') return '';
  return fileUrl.split('.').pop()?.toLowerCase();
};

const isImage = (fileUrl) => {
  if (typeof fileUrl !== 'string') return false;
  const ext = getFileExtension(fileUrl);
  return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
};
  return (
    <React.Fragment>
      <Row>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <Col className="col-12">
          <Card>
            <CardBody className="d-flex justify-content-between align-items-center">
              <CardTitle className="h4">Refund Management</CardTitle>
              <Link to="/add-course-refunds">
                <Button type="button" color="primary" className="waves-effect waves-light">
                  Add New Refund
                </Button>
              </Link>
            </CardBody>
            <CardBody>
              {loading ? (
                <div className="row">
                  <div className="col-md-2 offset-5">
                    <MutatingDots
                      visible={true}
                      height="100"
                      width="100"
                      color="#2B3A4A"
                      secondaryColor="#2B3A4A"
                      radius="12.5"
                      ariaLabel="mutating-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                </div>
              ) : (
                <MDBDataTable
                  responsive
                  bordered
                  data={data}
                  className="refund-table"
                />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} toggle={() => toggleDeleteModal(null)}>
        <ModalHeader toggle={() => toggleDeleteModal(null)}>Delete Refund Record</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this refund record? This action cannot be undone.
          {refundToDelete && (
            <div className="mt-3 p-3 bg-light rounded">
              <strong>Details:</strong><br />
              Roll No: {refundToDelete.roll_no}<br />
              Name: {refundToDelete.name}<br />
              Amount: {formatCurrency(refundToDelete.refund_amount)}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => toggleDeleteModal(null)}>Cancel</Button>
          <Button color="danger" onClick={handleDeleteRefund}>Delete</Button>
        </ModalFooter>
      </Modal>

      {/* File View Modal */}
      {/* File View Modal */}
      <Modal isOpen={fileModal} toggle={toggleFileModal} size="lg">
        <ModalHeader toggle={toggleFileModal}>Document Preview</ModalHeader>
        <ModalBody>
          {selectedFile ? (
            isImage(selectedFile) ? (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <img
                  src={`${backendFileUrl}${selectedFile}`}
                  alt="Document preview"
                  style={{ maxWidth: '100%', maxHeight: '500px' }}
                />
              </div>
            ) : (
              <div style={{ width: '100%', height: '500px' }}>
                <iframe
                  src={`${backendFileUrl}${selectedFile}`}
                  width="100%"
                  height="100%"
                  title="Document Preview"
                  style={{ border: 'none' }}
                />
              </div>
            )
          ) : (
            <p>No document available</p>
          )}
        </ModalBody>
        ...
      </Modal>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(RefundList);
